<template>
  <section>
    <v-input :htmlId="'MainAddressStreet'" :label="'Ulica'" :value="mainAddressStreet" />
    <v-input :htmlId="'MainAddressBuildingNo'" :label="'Numer domu'" :value="mainAddressBuildingNumber" />
    <v-input :htmlId="'MainAddressFlatNo'" :label="'Numer lokalu'" :value="mainAddressFlatNumber" />
    <v-input :htmlId="'MainAddressPostalCode'" :label="'Kod pocztowy'" :value="mainAddressPostalCode" />
    <v-input :htmlId="'MainAddressCity'" :label="'Miejscowość'" :value="mainAddressCity" />
    <!-- <v-select 
            :htmlId="'MainAddressProvinceId'" 
            :label="'Województwo'" 
            :list="provinces"
            :disable="disableProvince"
            :value="setProvinceValue" /> -->
    <v-select :htmlId="'MainAddressCountryId'" :label="'Kraj'" :list="countries" :searchable="true" @change="clearTaxOfficeData($event), setCountryName($event, 'setMainAddressCountry')" :value="mainAddressCountryId.toString()" />
  </section>
</template>

<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item'

export default {
  data() {
    return {
      plId: 160,
    }
  },
  props: {
    provinces: {
      type: Array,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
  },
  mixins: [getDictionaryItem],
  methods: {
    clearTaxOfficeData(e) {
      var isResident = e === 160
      if (isResident) {
        this.$store.commit('setTaxCityId', null)
        this.$store.commit('setTaxOfficeId', null)
        this.$store.commit('setMotherName', '')
        this.$store.commit('setFatherName', '')
      } else {
        /* Warszawa */
        this.$emit('updateAbroadTaxPlace')
      }

      this.$store.commit('setIsResident', isResident)
    },
    setCountryName(e, mutationName) {
      let countryName = this.getDictionaryItem(this.countries, 'text', 'value', parseInt(e))
      this.$store.commit(mutationName, countryName)
    },
  },
  computed: {
    mainAddressStreet() {
      return this.$store.getters.getMyFx && this.$store.getters.getMyFx.mainAddress.street ? this.$store.getters.getMyFx.mainAddress.street : ''
    },
    mainAddressBuildingNumber() {
      return this.$store.getters.getMyFx && this.$store.getters.getMyFx.mainAddress.buildingNumber ? this.$store.getters.getMyFx.mainAddress.buildingNumber : ''
    },
    mainAddressFlatNumber() {
      return this.$store.getters.getMyFx && this.$store.getters.getMyFx.mainAddress.flatNumber ? this.$store.getters.getMyFx.mainAddress.flatNumber : ''
    },
    mainAddressPostalCode() {
      return this.$store.getters.getMyFx && this.$store.getters.getMyFx.mainAddress.postalCode ? this.$store.getters.getMyFx.mainAddress.postalCode : ''
    },
    mainAddressCity() {
      return this.$store.getters.getMyFx && this.$store.getters.getMyFx.mainAddress.city ? this.$store.getters.getMyFx.mainAddress.city : ''
    },
    mainAddressProvinceId() {
      return this.$store.getters.getMyFx && this.$store.getters.getMyFx.mainAddress.provinceId ? this.$store.getters.getMyFx.mainAddress.provinceId : ''
    },
    mainAddressCountryId() {
      return this.$store.getters.getMyFx && this.$store.getters.getMyFx.mainAddress.countryId ? this.$store.getters.getMyFx.mainAddress.countryId : ''
    },
    // disableProvince() { return this.mainAddressCountryId !== this.plId },
    // setProvinceValue() { return this.mainAddressCountryId !== this.plId ? '' : this.mainAddressProvinceId.toString() }
  },
}
</script>
